import {APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import 'hammerjs';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { fuseConfig } from 'app/fuse-config';
import { AppComponent, AppUpdateBottomSheetComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import {appInitializerFactory, CoreModule} from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { JwtModule } from '@auth0/angular-jwt';
import { MVLocalStorageService } from './services/mv-local-storage.service';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FakeDbService } from 'app/fake-db/fake-db.service';
import { DialogModule } from 'app/dialogs/dialog.module';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import {TenantSelectorComponent} from './pages/tenant-selector/tenant-selector.component';
import { A2hsService } from './services/a2hs.service';
import { Observable, of } from 'rxjs';

class MyTranslateLoader implements TranslateLoader {
    constructor() {}
  
    public getTranslation(lang: string): Observable<any> {
      const translation = JSON.parse(MVLocalStorageService.getItem(lang + '.json'));
      return of(translation);
    }
  }
  // AoT requires an exported function for factories
export function MyTranslateLoaderFactory() {
    return new MyTranslateLoader();
  }

export function tokenGetter(): string {
    if (MVLocalStorageService.getItem('current_user')) {
        const user = JSON.parse(MVLocalStorageService.getItem('current_user'));
        return user.token;
    }

    return null;
}


@NgModule({
    declarations: [
        AppComponent,
        AppUpdateBottomSheetComponent,
        TenantSelectorComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CoreModule,
        AppRoutingModule,
        // ThemeBuilderRoutingModule,

        TranslateModule.forRoot({
            loader: {provide: TranslateLoader, useClass: MyTranslateLoader, deps: [HttpClient]}
        }),
        InMemoryWebApiModule.forRoot(FakeDbService, {
            delay: 1500,
            passThruUnknownUrl: true
        }),

        SharedModule,


        JwtModule.forRoot({
            config: {
                tokenGetter
                // tokenGetter: tokenGetter
            }
        }),

        // Material moment date module
        MatMomentDateModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        DialogModule,
        LayoutModule,
        MatBottomSheetModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        A2hsService
    ]
})
export class AppModule { }
